module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av739-76c458c8485b3fbad559002064455208.jpg";